import React, { useContext, useState } from "react";

import { useNavigate } from "react-router-dom";
import EmmaDiary from "assets/emmas-diary-logo.jpg";
import MyOffers from "assets/MyOffers.png";
import EveryDayHealthImg from "assets/eh.png";
import EAFHero from "assets/generated_images/address-finder.png";
import SectionWrapper from "../ui/SectionWrapper";
import { Link } from "react-router-dom";
import { OutletContext } from "../../layouts/DefaultLayout";
import CostCalculatorModal from "../CostCalculator/CostCalculatorModal";

const Feature: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="grid gap-6 md:grid-cols-[auto_1fr] items-start rounded-lg bg-white border border-gray-200 px-6 py-5">
    <div className="text-[15px] leading-relaxed text-[#4B5C73]">{children}</div>
  </div>
);

const EAF: React.FC = () => {
  const nav = useNavigate();
  const { setConsultOpen } = useContext(OutletContext);
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
  return (
    <SectionWrapper>
      {/* ================= HERO ================= */}
      <div className="rounded-b-lg bg-[#F2F4F7] overflow-hidden">
        {/* MOBILE → COLUMN | DESKTOP → ROW */}
        <div className="flex flex-col lg:flex-row">
          {/* IMAGE (TOP ON MOBILE, RIGHT ON DESKTOP) */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full h-[220px] sm:h-[280px] lg:w-[300px] lg:h-[500px] overflow-hidden flex items-center justify-center">
              <img
                src="/assets/optimized/address-finder-1200.jpg"
                alt="Enhanced Address Finder. Accurate, In Depth UK Location Services via API including information on Precise geo co-ordinates, property valuation, property type, number of bedrooms, Council Tax Band."
                loading="eager"
                decoding="async"
                className="
                    w-full h-full object-cover object-[50%_10%]
                    lg:w-auto lg:h-full lg:max-w-none
                "
              />
            </div>
          </div>

          {/* LEFT CONTENT */}
          <div className="flex-1 px-8 py-2 pb-6 order-2 lg:order-1">
            <p className="mt-6 text-[15px] leading-relaxed text-[#4B5C73] max-w-xl">
              A product we have developed in-house over the last seven years for
              companies who already use an API based UK postal address look-up
              solution on their websites.
            </p>

            <div className="my-4">
              <button
                className="inline-flex rounded-md bg-[#0B2545] px-6 py-3 text-sm font-medium text-white hover:bg-[#091D35] transition"
                onClick={() => setConsultOpen(true)}
              >
                Request Consultation
              </button>
            </div>

            {/* <p className="mt-4 text-[15px] leading-relaxed text-[#4B5C73] max-w-xl">
              There are many providers in the market, what sets us apart is that
              we not only provide significant cost savings, but the option of
              taking other information with the address chosen by a customer.
            </p> */}

            {/* DATA TODAY */}
            {/* <div className="mt-6 space-y-6">
            <h2 className="text-xl sm:text-2xl font-semibold text-[#0B2545]">
              Data returned today
            </h2>

            <div className="grid gap-6">
              <Feature>Unique Property Reference Number (UPRN)</Feature>
              <Feature>Precise geo co-ordinates, latitude and longitude</Feature>
              <Feature>£ property valuation.</Feature>
            </div>
          </div> */}

            {/* ROADMAP */}

            {/* LINKS */}
            <div className="my-6 space-y-4 text-[15px] text-[#4B5C73] max-w-3xl">
              <p>
                Explore the system yourself on{" "}
                <a
                  href="https://enhancedaddressfinder.co.uk"
                  className="font-medium text-blue-600 hover:underline"
                >
                  our test environment
                </a>
                .
              </p>

              <p>
                Estimate potential savings for your organisation using our{" "}
                <a
                  onClick={() => setIsCalculatorOpen(true)}
                  className="font-medium text-blue-600 hover:underline"
                >
                  cost comparison tool
                </a>
                .
              </p>
            </div>
            <div className="mt-4">
              <div className="flex gap-4">
                <button
                  onClick={() => setIsCalculatorOpen(true)}
                  className="rounded bg-[#CC0000] hover:bg-[#990000]  px-4 py-2 text-white"
                >
                  Cost Calculator
                </button>
                <button
                  onClick={() => {
                    window.open("https://enhancedaddressfinder.co.uk");
                  }}
                  className="rounded bg-[#CC0000] hover:bg-[#990000]  px-4 py-2 text-white"
                >
                  Test our system
                </button>
              </div>

              {/* Modal */}
              <CostCalculatorModal
                isOpen={isCalculatorOpen}
                onClose={() => setIsCalculatorOpen(false)}
              />
            </div>
          </div>
        </div>

        {/*<div className="px-8 pt-4 pb-4">

           <div className="my-8 space-y-6">
            <h2 className="text-xl sm:text-2xl font-semibold text-[#0B2545]">
              Other items to be released in 2026:
            </h2>

            <div className="grid gap-6">
              <Feature>
                Property type e.g. flat, terraced house, semi detached house,
                detached house...
              </Feature>

              <Feature>Number of bedrooms</Feature>

              <Feature>
                Council Tax Band – the actual CTB (A-H) and name of the local
                authority
              </Feature>
            </div>
          </div> *
        </div>/}

        {/* ORGANISATIONS */}
        <div className="px-8 py-2">
          <h3 className="text-lg font-semibold text-[#0B2545] py-4">
            Companies we support
          </h3>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-48 items-center max-w-md -mt-2 pb-6 p;-24">
            <Link
              to="/success-stories/emmas-diary"
              className="flex items-center justify-center h-32 w-40"
            >
              <img
                src={EmmaDiary}
                alt="EmmaDiary"
                className="max-h-full max-w-full object-contain"
              />
            </Link>

            <Link to="" className="flex items-center justify-center h-32 w-40">
              <img
                src={MyOffers}
                alt="MyOffers"
                className="max-h-full max-w-full object-contain"
              />
            </Link>

            <Link to="" className="flex items-center justify-center h-32 w-40">
              <img
                src={EveryDayHealthImg}
                alt="Everyday Health"
                className="max-h-full max-w-full object-contain"
              />
            </Link>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default EAF;
